import React from "react";
import "../css/style.css";

const Reports = () => {
  return <div className="main-content"></div>;
};

export default Reports;
